import { Component, Output, OnInit, EventEmitter, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'delete-alert-component',
  templateUrl: './delete-alert.component.html',
  styleUrls: ['./delete-alert.component.scss'],
})
export class DeleteAlertComponent implements OnInit {
  @Input() title: string;
  @Input() deleteItem: string;

  @Output() isDelete = new EventEmitter();

  constructor(private modalController: ModalController) { }

  ngOnInit() { }

  dismiss() {
    this.modalController.dismiss();
  }

  delete() {
    this.modalController.dismiss(this.deleteItem);
  }
}